import mascotWebDesign from '../../assets/teams/webdesign.png';
import mascotFrontEnd from '../../assets/teams/frontend.png';
import mascotInfra from '../../assets/teams/infra.png';
import mascotGameDev from '../../assets/teams/gamedev.png';
import mascotGameDesign from '../../assets/teams/gamedesign.png';
import scrollWebDesignClose from '../../assets/teams/webdesign_close.png';
import scrollWebDesignOpen from '../../assets/teams/webdesign_open.png';
import scrollFrontEndClose from '../../assets/teams/frontend_close.png';
import scrollFrontEndOpen from '../../assets/teams/frontend_open.png';
import scrollInfraClose from '../../assets/teams/infrastructure_close.png';
import scrollInfraOpen from '../../assets/teams/infrastructure_open.png';
import scrollGameDevClose from '../../assets/teams/gamedev_close.png';
import scrollGameDevOpen from '../../assets/teams/gamedev_open.png';
import scrollGameDesignClose from '../../assets/teams/gamedesign_close.png';
import scrollGameDesignOpen from '../../assets/teams/gamedesign_open.png';

export const content = [
  {
    title: 'WEB DESIGN',
    scheme: '#9d89a2',
    mascot: mascotWebDesign,
    scroll: {
      close: scrollWebDesignClose,
      open: scrollWebDesignOpen,
    },
    details:
      'Web Design จะปูพื้นฐานน้อง ๆ เกี่ยวกับการออกแบบ องค์ประกอบในการออกแบบต่าง ๆ และให้ความรู้เกี่ยวกับเรื่องของลิขสิทธิ์ รวมถึงเนื้อหาที่น่าสนใจอื่น ๆ ผ่านเวิร์กชอปต่าง ๆ ที่พี่ ๆ ได้เตรียมไว้ เพื่อจะนำไปต่อยอดกับการออกแบบเว็บไซต์ ที่จะถูกนำมาเป็นโปรเจกต์ที่ร่วมทำกับฝ่ายอื่น ๆ ในช่วงท้ายของโครงการ',
  },
  {
    title: 'FRONT END',
    scheme: '#a8b9c9',
    mascot: mascotFrontEnd,
    scroll: {
      close: scrollFrontEndClose,
      open: scrollFrontEndOpen,
    },
    details:
      'ฝ่าย Front-End จะปูพื้นฐานการพัฒนาเว็บไซต์ด้วยภาษาต่าง ๆ ไม่ว่าจะเป็น HTML CSS และ JavaScript เพื่อที่จะไปต่อยอดกับการใช้ไลบรารีที่ได้รับความนิยมอย่าง React และน้อง ๆ จะได้สร้างเว็บไซต์ขึ้นมาจริง ๆ โดยทำงานร่วมกับฝ่ายอื่น ๆ ซึ่งจะทำให้ได้ทักษะการทำงานร่วมกันเป็นทีมอีกด้วย',
  },
  {
    title: 'INFRASTRUCTURE',
    scheme: '#80af97',
    mascot: mascotInfra,
    scroll: {
      close: scrollInfraClose,
      open: scrollInfraOpen,
    },
    details:
      'ในฝ่าย Infrastructure น้อง ๆ จะได้เรียนรู้เกี่ยวกับวิธีการและขั้นตอนการทำให้เว็บไซต์ที่ถูกเขียนขึ้นมาแล้ว สามารถเยี่ยมชมโดยผู้ใช้ภายนอกผ่าน Domain ที่เราตั้งไว้ได้ และน้อง ๆ ยังจะได้รู้จักวิธีการใช้ CLI หรือ Command Line Interface และหัวข้อที่เกี่ยวข้องอื่น ๆ รวมถึงได้เสริมทักษะการทำงานร่วมกันเป็นทีมอีกด้วย',
  },
  {
    title: 'GAME DEVELOPMENT',
    scheme: '#cdc191',
    mascot: mascotGameDev,
    scroll: {
      close: scrollGameDevClose,
      open: scrollGameDevOpen,
    },
    details:
      'ฝ่าย Game Development จะพาน้อง ๆ ไปเรียนรู้เกี่ยวกับการสร้างเกมอย่างแท้จริง ว่าเกมบนเว็บเบราว์เซอร์มีองค์ประกอบอะไรบ้าง และน้อง ๆ จะได้มีโอกาสสร้างเกมของตัวเองที่สามารถเล่นได้จริงบนเว็บไซต์ รับรองว่าทั้งสนุก และอัดแน่นไปด้วยความรู้อย่างแน่นอน',
  },
  {
    title: 'GAME DESIGN',
    scheme: '#dd93a9',
    mascot: mascotGameDesign,
    scroll: {
      close: scrollGameDesignClose,
      open: scrollGameDesignOpen,
    },
    details:
      'เมื่อเข้ามาในฝ่าย Game Design น้อง ๆ จะได้เรียนรู้ถึงหลักการ วิธีการออกแบบ และ ปัจจัยในการออกแบบเกมให้มีความน่าสนใจ รวมถึงองค์ประกอบของเกมเกมหนึ่งด้วย น้อง ๆ จะได้สร้างตัวละคร รวมถึง Game Play ที่ผ่านจินตนาการของน้อง ๆ และจะถูกนำไปใช้ในการสร้างเกมจริง ๆ อีกด้วย',
  },
];